var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"1px"}},[(_vm.flashSaleList.length > 0)?_c('flashSale',{attrs:{"title":"限时抢购","fromCom":"timeLimit","hideTitle":true,"dataList":_vm.flashSaleList}}):_c('van-empty',{attrs:{"description":"暂无商品信息,敬请期待"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }